var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"small"},[_c('line-chart',{attrs:{"chart-data":_vm.datacollection}}),_c('button',{staticClass:"button is-info",on:{"click":function($event){return _vm.fillData()}}},[_vm._v("Randomize")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }